<template>
  <div class="card  mgb-100px">
    <a ref="lienDownload" />
    <header class="header-card">
      <p>{{ $t('detailContrat.echeancier.title')}}</p>
    </header>
    <div class="card-content">
      <error-msg-component :messages="messages"
                             :error="error"
                             :messagesChampsVide="messagesChampsVide"
                             :champsVide="champsVide"
                             :title="'editionClient.problemOccurred'"
                             :withEmplyFields="true"
                             @close="error = $event"/>
      <div v-if="getListeEcheanceOutsideRange.length > 0" class="mgb-20px">
        <app-information-msg-component
          title="ajoutEditContrat.echeancier.info.echeanceOutsideTitle"
          :libelleList="getListeEcheanceOutsideRange"
          :canClose="false"/>
      </div>
      <div v-if="getListeMessageBlocage.length > 0" class="mgb-20px">
        <app-information-msg-component
          title="detailContrat.blocagePaiement"
          :libelleList="getListeMessageBlocage"
          :canClose="false"/>
      </div>
      <div class="columns">
        <div class="column is-7 is-8-fullhd">
          <div class="columns is-multiline">
            <div class="column is-narrow" v-for="(bailleur, index) in bailleurList"
                 :key="index">
              <qd-checkbox v-model="bailleur.mustAppearInEcheanceList">
                {{ bailleur.libelle }}
              </qd-checkbox>
            </div>
          </div>
        </div>
        <div class="column is-4 is-3-fullhd has-text-right">
          <qd-checkbox v-model="masquerEcheancePaye">
            {{ $t('detailContrat.actions.masquerEcheancePaye') }}
          </qd-checkbox>
        </div>
        <div class="column is-narrow">
          <exportExcelButton
            :perm="constantes.CONTRAT.exporter"
            :query="exportExcelQuery"/>
        </div>
      </div>
      <div class="card transparentCardNoBorder">
        <div class="card-content pdb-5px pdt-0">
          <div class="columns">
            <div class="column is-narrow">
              <b-icon icon="chevron-right"
                      type="is-default" class="is-invisible"></b-icon>
            </div>
            <div class="column is-3 has-text-link has-text-weight-bold has-text-link">
              {{ $t('detailContrat.echeancier.periodeEcheance')}}
            </div>
            <div class="column is-2 has-text-link has-text-weight-bold">
              {{ $t('detailContrat.echeancier.montantHt')}}
            </div>
            <div class="column is-2 has-text-link has-text-weight-bold">
              {{ $t('detailContrat.echeancier.blocagePaiement')}}
            </div>
            <div class="column is-2 has-text-link has-text-weight-bold">
              {{ $t('detailContrat.echeancier.histo')}}
            </div>
            <div class="column is-2 has-text-link has-text-weight-bold">
              {{ $t('detailContrat.echeancier.termePaiement')}}
            </div>
          </div>
        </div>
      </div>
      <div class="card has-background-background overflow-auto">
        <div class="card-content">
          <div class="columns">
            <div class="column is-narrow is-cursor-pointer"
                 @click="afficherEcheancier = !afficherEcheancier">
              <b-icon :icon="afficherEcheancier ? 'chevron-down' : 'chevron-right'"
                      type="is-default"></b-icon>
            </div>
            <div class="column is-3 has-text-link">
              <span class="has-text-weight-bold"
                    v-if="getSmallestDateDebut && getHeightestDateFin">
                {{ $t('detailContrat.echeancier.dateEcheancier',
                { dateDebut: getSmallestDateDebut,
                  dateFin: getHeightestDateFin }) }}
              </span>
            </div>
            <div class="column is-2">
              {{ getTotalGeneral('montantHt') | formatDevise}}
            </div>
            <div class="column is-2">
              <div class="columns">
                <qd-switch v-model="contrat.blocageReglement"
                          disabled
                          class="pdr-0 mgr-0
                          column is-narrow">
                </qd-switch>
                <span class="column is-10 pdl-0">
                  {{ getMotifBlocageLibelle(contrat.motifBlocageId) }}
                </span>
              </div>
            </div>
            <div class="column is-2">
              <div class="columns">
                <qd-switch v-model="avecHisto"
                  @input="loadEcheancier"
                  class="pdr-0 mgr-0
                  column is-narrow">
                </qd-switch>
              </div>
            </div>
            <div class="column is-2">
              <div class="columns">
                <span
                  class="pdr-0 mgr-0
                  column is-narrow">
                  {{ $t(getTermePaiement(contrat.termePaiement)) }}
                </span>
              </div>
            </div>
          </div>
          <div class="columns">
              <div class="column is-narrow">
                <selecteur-action
                  @handleAction="handleAction"
                  :options='actions'
                  :placeholder='$t("general.placeHolder.groupedAction")'
                  :titleButton="'general.button.apply'"
                  :elementsSelectionnes="getAllEcheanceSelected().length > 0"
                ></selecteur-action>
              </div>
            </div>
          <div v-if="contrat.echeancier.length > 0 && afficherEcheancier"
               class="mgb-300px">
            <table class="VueTables__table table is-bordered is-fullwidth is-striped">
              <thead>
              <th @click="selectAll" class="is-cursor-pointer">
                    <b-icon :icon="iconSelectTotal"></b-icon></th>
              <th>{{ $t('detailContrat.echeancier.tabEcheance.bailleur') }}</th>
              <th>{{ $t('detailContrat.echeancier.tabEcheance.produit') }}</th>
              <th>
                {{ $t('detailContrat.echeancier.tabEcheance.dateEcheance') }}
                <a @click="updateSort('dateEcheance', 'date')"
                   class="is-pulled-right">
                  <b-icon :icon="getIconSort('dateEcheance')"
                          size="is-small">
                  </b-icon>
                </a>
              </th>
              <th>{{ $t('detailContrat.echeancier.tabEcheance.tauxTva') }}</th>
              <th>
                {{ $t('detailContrat.echeancier.tabEcheance.montantHt') }}
                <a @click="updateSort('montantHt', 'montant')"
                   class="is-pulled-right">
                  <b-icon :icon="getIconSort('montantHt')"
                          size="is-small">
                  </b-icon>
                </a>
              </th>
              <th>
                {{ $t('detailContrat.echeancier.tabEcheance.montantTtc') }}
                <a @click="updateSort('montantTtc', 'montant')"
                   class="is-pulled-right">
                  <b-icon :icon="getIconSort('montantTtc')"
                          size="is-small">
                  </b-icon>
                </a>
              </th>
              <th>{{ $t('detailContrat.echeancier.tabEcheance.modePaiement') }}</th>
              <th>
                {{ $t('detailContrat.echeancier.tabEcheance.debut') }}
                <a @click="updateSort('debutPeriode', 'date')"
                   class="is-pulled-right">
                  <b-icon :icon="getIconSort('debutPeriode')"
                          size="is-small">
                  </b-icon>
                </a>
              </th>
              <th>
                {{ $t('detailContrat.echeancier.tabEcheance.fin') }}
                <a @click="updateSort('finPeriode', 'date')"
                   class="is-pulled-right">
                  <b-icon :icon="getIconSort('finPeriode')"
                          size="is-small">
                  </b-icon>
                </a>
              </th>
              <th>{{ $t('detailContrat.echeancier.tabEcheance.aRapprocher') }}</th>
              <th>
                {{ $t('detailContrat.echeancier.tabEcheance.montantFactureAchatTtc') }}
                <a @click="updateSort('montantAppele', 'montant')"
                   class="is-pulled-right">
                  <b-icon :icon="getIconSort('montantAppele')"
                          size="is-small">
                  </b-icon>
                </a>
              </th>
              <th>
                {{ $t('detailContrat.echeancier.tabEcheance.montantPaye') }}
                <a @click="updateSort('montantEcheancierPaye', 'montant')"
                   class="is-pulled-right">
                  <b-icon :icon="getIconSort('montantEcheancierPaye')"
                          size="is-small">
                  </b-icon>
                </a>
              </th>
              <th>{{ $t('detailContrat.echeancier.tabEcheance.paye') }}</th>
              <th></th>
              <th></th>
              </thead>
              <tbody>
              <template v-for="bailleur in bailleurList">
                <tr v-for="(ligne) in
              getLignesWithTiersId(bailleur.tiersId, bailleur.mustAppearInEcheanceList)"
                    :key="ligne.id"
                    :class="{'background-information-table' : indicationLigneEcheance(ligne) }">
                  <td class="pd-3px has-text-centered is-vertical">
                    <qd-checkbox v-model="ligne.selected"
                                class="mgt-10px pdl-5px"></qd-checkbox>
                  </td>
                  <td>
                    <section class="is-flex is-justify-content-space-between">
                      <span class="pdr-2"> {{ getLibelleTier(ligne.tiersId) }} </span>
                      <a
                        v-if="ligne.valeurIndexationActuel"
                        @click="showIndexationEcheancier(ligne)">
                        <b-tooltip
                          :label="$t('detailContrat.indexation.affichageDonneeIndexation')"
                          position="is-right">
                            <b-icon type="is-primary" icon="cash-plus" size="small"/>
                        </b-tooltip>
                      </a>
                    </section>
                  </td>
                  <td>
                    <router-link-blank
                      :to="{
                        name: 'c.baux.commande_achat-bailleur',
                        params: {
                          id: ligne.devisCommandeId,
                        },
                      }"
                      class="has-text-centered"
                      :message="getProduitLocationEtDiversLibelle(ligne)">
                    </router-link-blank>
                  </td>
                  <td>{{ ligne.dateEcheance | formatDate }}</td>
                  <td>{{ ligne.pourcentageTva | formatPercent }}</td>
                  <td class="has-text-right">{{ ligne.montantHt | formatDevise }}</td>
                  <td class="has-text-right">
                    {{ ligne.montantTtc | formatDevise }}
                  </td>
                  <td class="has-text-right">
                    {{ ligne.modeReglement ? ligne.modeReglement.libelle : '' }}
                  </td>
                  <td>{{ ligne.debutPeriode | formatDate}}</td>
                  <td>{{ ligne.finPeriode | formatDate}}</td>
                  <td class="has-text-centered">
                    <qd-checkbox v-model="ligne.aRapprocher" class="mgt-5px"
                                disabled>
                    </qd-checkbox>
                  </td>
                  <td class="has-text-right">
                    <b-tooltip type='is-white' position="is-left"
                    :active="ligne.factures && ligne.factures.length >0">
                      <template v-slot:content>
                        <echeanceFacturesTable :commande="ligne" />
                      </template>
                    <router-link-blank
                      v-if="ligne.factures && ligne.factures.length > 0"
                      :to="{ name: getRouteNameFacture(ligne),
                            params: getParamsFacture(ligne) }"
                      :message="ligne.montantAppele | formatDevise">
                    </router-link-blank>
                    <span v-else>{{ colFacturee(ligne) }}</span>
                    </b-tooltip>
                  </td>
                  <td class="has-text-right">
                    <b-tooltip type='is-white' position="is-left"
                      :active="ligne.factures && ligne.factures.length >0">
                      <template v-slot:content>
                        <echeancePaiementsTable :commande="ligne" showTypePiece/>
                      </template>
                      <span v-if="getIdsPiece(ligne).length === 0">{{ colPayee(ligne) }}</span>
                      <router-link-blank
                        v-else-if="getRoutePiece(ligne)"
                        v-bind="getRoutePiece(ligne)">
                      </router-link-blank>
                      <a v-else
                        @click="openPopupPaiement(ligne)"
                        class="lien">
                        {{ getMontantPaye(ligne) | formatDevise }}
                      </a>
                    </b-tooltip>
                  </td>
                  <td class="pd-3px has-text-centered">
                    <div class="has-text-link has-text-centered pd-5px">
                      <qd-checkbox class="mgl-10px" disabled
                                  :value="isPaid(ligne)">
                      </qd-checkbox>
                    </div>
                  </td>
                  <td>
                    <dropdownButton
                      v-if="ligne.montantHt === 0"
                      :type="canPay(ligne) ? 'is-primary'
                      : 'is-forbidden'"
                      :classButton="'is-fullwidth'"
                      :class="'is-flex'"
                      :actions="actionSecondary(ligne)"
                      @click="solderSansFacture(ligne)">
                        {{ $t('detailContrat.echeancier.tabEcheance.actions.solder') }}
                    </dropdownButton>
                    <dropdownButton
                      v-else
                      :type="canPay(ligne) ? 'is-primary'
                      : 'is-forbidden'"
                      :classButton="'is-fullwidth'"
                      :class="'is-flex'"
                      :actions="actionSecondaryPay(ligne)"
                      @click="payer(ligne)">
                        {{ $t('detailContrat.echeancier.tabEcheance.actions.payer') }}
                    </dropdownButton>
                  </td>
                  <td>
                    <verticalDotsDropdown
                      class="is-relative"
                      :dropdownItems="dropdownItems(ligne)"/>
                  </td>
                  <td class="pd-5px has-text-centered vertical-alignment is-cursor-pointer"
                      @click="setCommentaireList(ligne)"
                      v-if="ligne.commentaires.length > 0 || ligne.commentaire">
                    <b-icon type="is-primary" icon="information" size="small">
                    </b-icon>
                  </td>
                  <td v-else></td>
                </tr>
                <tr :key="bailleur.tiersId" class="has-text-link"
                    v-if="(getLignesWithTiersId(bailleur.tiersId,
                  bailleur.mustAppearInEcheanceList)).length > 0">
                  <td colspan="2">
                    <div class="has-text-link has-text-weight-bold">
                      {{ $t('ajoutEditContrat.echeancier.tabEcheance.totalBailleur',
                      { bailleur: getLibelleTier(bailleur.tiersId) }) }}
                    </div>
                  </td>
                  <td colspan="3"></td>
                  <td>
                    <div class="has-text-link has-text-weight-bold has-text-right">
                      {{ getMontantByTiers(bailleur.tiersId, 'montantHt') | formatDevise }}
                    </div>
                  </td>
                  <td>
                    <div class="has-text-link has-text-weight-bold has-text-right">
                      {{ getMontantByTiers(bailleur.tiersId, 'montantTtc') | formatDevise }}
                    </div>
                  </td>
                  <td colspan="4"></td>
                  <td>
                    <div class="has-text-link has-text-weight-bold has-text-right">
                      {{ getMontantByTiers(bailleur.tiersId, 'montantAppele') | formatDevise }}
                    </div>
                  </td>
                  <td>
                    <div class="has-text-link has-text-weight-bold has-text-right">
                      {{ getMontantByTiers(bailleur.tiersId, 'montantEcheancierPaye')
                      | formatDevise }}
                    </div>
                  </td>
                  <td colspan="4"></td>
                </tr>
              </template>
              <tr class="has-text-link" v-if="hasMultipleBailleurInList > 1">
                <td>
                  <div class="has-text-link has-text-weight-bold">
                    {{ $t('ajoutEditContrat.echeancier.tabEcheance.totalBailleur',
                    { bailleur: '' }) }}
                  </div>
                </td>
                <td colspan="4"></td>
                <td>
                  <div class="has-text-link has-text-weight-bold has-text-right">
                    {{ getTotalGeneral('montantHt') | formatDevise }}
                  </div>
                </td>
                <td>
                  <div class="has-text-link has-text-weight-bold has-text-right">
                    {{ getTotalGeneral('montantTtc') | formatDevise }}
                  </div>
                </td>
                <td colspan="4"></td>
                <td>
                  <div class="has-text-link has-text-weight-bold has-text-right">
                      {{ getTotalGeneral('montantAppele') | formatDevise }}
                  </div>
                </td>
                <td>
                  <div class="has-text-link has-text-weight-bold has-text-right">
                    {{ getTotalGeneral('montantEcheancierPaye') | formatDevise }}
                  </div>
                </td>
                <td colspan="3"></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="viewDetailProduits" has-modal-card class="modal modal-width-1250px">
      <detail-produit-list :produits="echeance.listeProduits" :echeance="echeance"
                           :dateDebut="contrat.dateDebutSignature"
                           :dateFin="contrat.dateFinSignature">
      </detail-produit-list>
    </b-modal>
    <b-modal v-model="popUpInformationCommentaire" has-modal-card class="modal" :width="500">
      <information-commentaires :echeance="echeanceInfoCommentaire"></information-commentaires>
    </b-modal>
    <b-modal v-model="displayPopupPayer" has-modal-card class="modal" width="600px"
     v-if="lineSelected !== null">
      <popup-payer
        :devisCommandeId="lineSelected.devisCommandeId"
        :modeReglementId="lineSelected.modeReglementId"
        :modeReglementLibelle="lineSelected.modeReglement.libelle"
        :dateEcheance="lineSelected.dateEcheance"
        :dateDebut="lineSelected.debutPeriode"
        :dateFin="lineSelected.finPeriode"
        :montantAPayer="lineSelected.montantTtc - lineSelected.montantPaye"
        :tiersId="lineSelected.tiersId"
        :tiersLibelle="lineSelected.tiers.nomCommercial"
        :contratCode="contrat.code"
        @refresh="closeAndSearch" />
    </b-modal>
    <b-modal v-model="displayPopupAnnulationPaiement" has-modal-card class="modal" width="800px"
     v-if="lineSelected !== null">
      <popup-annulation-paiement
        :echeance="lineSelected"
        @refresh="closeAndSearch" />
    </b-modal>
     <b-modal v-model="popUpAnnulation.show" has-modal-card class="modal"
          @close="popUpAnnulation.show = false">
          <pop-up-prevention
              :messHeader="$t('detailContrat.echeancier.annulerCharge.titre')"
              :labelCheckbox="this.$t('detailContrat.echeancier.annulerCharge.checkbox')"
              :cancel="$t('general.non')"
              :validate="$t('general.oui')"
              @no="popUpAnnulation.show = false"
              @yes="value => annulerCharge(popUpAnnulation.target, value)">
          </pop-up-prevention>
      </b-modal>
    <b-modal v-model="popUpGeneration" has-modal-card class="modal"
      @close="popUpGeneration = false">
      <pop-up-prevention
          :messHeader="$t('detailContrat.echeancier.generationFacture')"
          v-bind="popUpPrevention"
          :cancel="$t('general.non')"
          :validate="$t('general.oui')"
          @no="popUpGeneration = false"
          @yes="generationFacture">
      </pop-up-prevention>
    </b-modal>
    <b-modal
      v-model="popUpIndexationEch"
      class="modal"
      has-modal-card
      @close="popUpIndexationEch = false">
      <pop-up-indexation-echeancier
        :echeancier="lineSelected"
        @close="popUpIndexationEch = false"
      />
    </b-modal>
    <b-modal
      v-model="isPopupPaiment"
      @close="hidePopupPaiement()"
      class="modal"
      has-modal-card>
        <popup-paiement :ligne="ligneEcheancierSelectionnee" />
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import dropdownButton from '@/components/general/button/dropdownButton';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import formatDate from '@/services/general/formatDate';
import sortEcheance from '@/services/baux/contrat/sortEcheance';
import detailProduitList from '@/components/gabed/contrat/commun/p_detailProduitList';
import informationCommentaires from '@/components/baux/contrat/componentEdition/p_informationCommentaires';
import { PARAMETRES_KEYS, PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import AppInformationMsgComponent from '@/components/general/informationMsgComponent';
import selecteurAction from '@/components/general/selecteurAction';
import popupPayer from '@/components/baux/contrat/componentEdition/popupPayer';
import popupAnnulationPaiement from '@/components/baux/contrat/componentEdition/popupAnnulationPaiement';
import popUpIndexationEcheancier from '@/components/baux/contrat/componentDetail/popUpIndexationEcheancier';
import popupPaiement from '@/components/baux/contrat/componentDetail/popUpPaiement';
import echeanceFacturesTable from '@/components/baux/contrat/echeancesContratTooltipTable/echeanceFacturesTable';
import echeancePaiementsTable from '@/components/baux/contrat/echeancesContratTooltipTable/echeancePaiementsTable';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import * as contratConf from '@/configuration/baux/contrat/contratConf';
import popUpPrevention from '@/components/general/popUpPrevention';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import {
  getEcheancierContrat,
  getEcheancierContrats,
  solderSansFacture,
  reactiverSuiteSoldeSansFacture,
} from '@/api/commandeAchat';
import { suppressionCharge } from '@/api/factureAchat';
import messageSucces from '@/services/general/messageSucces';
import validationGeneral from '@/services/validation/validation';
import validationEcheance from '@/services/baux/contrat/validationEcheance';
import {
  ECHEANCE_BROUILLON,
  ECHEANCE_PAYEE,
  ECHEANCE_FACTURE,
  ECHEANCE_FACTURE_PARTIELLEMENT,
  ACTION_SOLDER_SANS_FACTURE,
  ACTION_REACTIVER_ECHEANCE_SOLDEE,
  ACTION_GENERATION_FACTURE,
} from '@/configuration/baux/contrat/echeancier/echeancier';
import {
  EXPORT_EXCEL_TYPE_DONNEES_COMMANDE,
  EXPORT_EXCEL_TYPE_EXPORT_ECHEANCIER,
} from '@/configuration/commande/commandeConf';
import { CONTRAT } from '@/configuration/baux/permissionsBauxConf';
import { formatDevise } from '@/services/general/filters/formatDevise';
import verticalDotsDropdown from '@/components/general/button/verticalDotsDropdown';
import { TYPE_OD } from '@/configuration/compta/ecritureConf';
import { factureGenerationFromEcheances } from '@/api/factureAchatARapprocher';
import { ENREGISTRE } from '@/configuration/relances/relancesConf';
import { CHARGE } from '@/configuration/mouvementClient/mouvementClientConf';
import edition from '@/api/edition';
import { TYPE_EDITION_DEMANDE_AVOIR_BAILLEUR } from '@/configuration/baux/contrat/contratConf';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'BauxContratDetailEcheancier',
  props: {
    contrat: {
      type: Object,
      required: true,
    },
    echeancier: {
      type: Object,
      required: true,
    },
  },
  components: {
    verticalDotsDropdown,
    dropdownButton,
    detailProduitList,
    informationCommentaires,
    routerLinkBlank,
    AppInformationMsgComponent,
    popupPayer,
    popupAnnulationPaiement,
    popUpIndexationEcheancier,
    selecteurAction,
    errorMsgComponent,
    popUpPrevention,
    exportExcelButton,
    echeanceFacturesTable,
    echeancePaiementsTable,
    popupPaiement,
  },
  data() {
    return {
      afficherEcheancier: false,
      bailleurList: [],
      echeanceInfoCommentaire: {},
      popUpInformationCommentaire: false,
      popUpIndexationEch: false,
      echeance: {},
      viewDetailProduits: false,
      masquerEcheancePaye: false,
      sort: {
        name: null,
        sens: 'DESC',
        type: null,
      },
      popUpAnnulation: {
        show: false,
        target: {},
      },
      displayPopupPayer: false,
      displayPopupAnnulationPaiement: false,
      lineSelected: null,
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      error: false,
      popUpGeneration: false,
      popUpPrevention: {
        messagesPopup: [],
        champsVide: [],
        messagesChampsVide: [],
        isErrorPopup: false,
      },
      avecHisto: false,
      constantes: {
        CONTRAT,
      },
      ligneEcheancierSelectionnee: null,
      isPopupPaiment: false,
    };
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    getIdsPiece(ligne) {
      let ids = [];
      if (ligne.factures === undefined || ligne.factures === null) return ids;
      ligne.factures.forEach((facture) => {
        ids = ids.concat(facture.paiementsIds);
      });
      return [...new Set(ids)];
    },
    getMontantPaye(ligne) {
      return ligne.aRapprocher
        ? ligne.montantEcheancierPaye : ligne.montantPaye;
    },
    getRoutePiece(ligne) {
      const ids = this.getIdsPiece(ligne);
      const typePieces = [...new Set(ligne.factures.flatMap(f => f.listePaiement
        .map(p => p.typeDePiece)))];
      const message = ligne.aRapprocher
        ? formatDevise(ligne.montantEcheancierPaye) : formatDevise(ligne.montantPaye);

      if (typePieces.length !== 1) return null;

      const type = typePieces[0];
      const isMultiple = ids.length > 1;
      const idParam = isMultiple ? JSON.stringify(ids) : ids[0];

      if (type === TYPE_OD) {
        return {
          to: {
            name: isMultiple ? 'l.comptabilite.operation_diverse' : 'c.comptabilite.operation_diverse',
            params: { [isMultiple ? 'idsOd' : 'id']: idParam },
          },
          message,
        };
      }

      if (type === CHARGE) {
        return {
          to: {
            // eslint-disable-next-line no-nested-ternary
            name: isMultiple
              ? (ligne.aRapprocher ? 'l.baux.facture_achat-bailleur-idsFactures' : 'l.baux.facture_achat-idsFactures')
              : 'c.baux.facture_achat',
            params: { [isMultiple ? 'idsFactures' : 'id']: idParam },
          },
          message,
        };
      }

      return {
        to: {
          name: isMultiple ? 'l.baux.lot_paiement' : 'c.baux.lot_paiement',
          params: { [isMultiple ? 'idsLots' : 'id']: idParam },
        },
        message,
      };
    },
    openPopupPaiement(ligne) {
      this.ligneEcheancierSelectionnee = ligne;
      this.isPopupPaiment = true;
    },
    hidePopupPaiement() {
      this.isPopupPaiment = false;
      this.ligneEcheancierSelectionnee = null;
    },
    getRouteNameFacture(ligne) {
      if (ligne.factures !== undefined
        && ligne.factures !== null
        && ligne.factures.length === 1) return 'c.baux.facture_achat';
      if (ligne.aRapprocher) return 'l.baux.facture_achat-bailleur';
      return 'l.baux.facture_achat';
    },
    getParamsFacture(ligne) {
      if (ligne.factures === undefined || ligne.factures === null) return null;
      if (ligne.factures.length === 1) return { id: ligne.factures[0].id };
      return {
        idDevisCommande: ligne.devisCommandeId,
      };
    },
    updateSort(sort, typeSort) {
      if (sort !== this.sort.name) {
        this.sort = {
          name: sort,
          sens: 'DESC',
          typeSort: typeSort,
        };
        return;
      }
      this.sort.sens = this.sort.sens === 'DESC' ? 'ACS' : 'DESC';
    },
    getIconSort(sort) {
      if (sort !== this.sort.name) return 'sort';
      return this.sort.sens === 'DESC' ? 'chevron-up' : 'chevron-down';
    },
    setCommentaireList(echeance) {
      this.echeanceInfoCommentaire = echeance;
      this.popUpInformationCommentaire = true;
    },
    getDate(date) {
      return formatDate(date);
    },
    setDetailProduit(echeance) {
      if (echeance.listeProduits.length === 0) return;
      this.echeance = echeance;
      this.viewDetailProduits = true;
    },
    indicationLigneEcheance(ligne) {
      return this.$route.name === 'c.baux.contrat-facture-in-echeancier'
        && ligne.devisCommandeId === this.$route.params.idCommandeAchat;
    },
    getLibelleTier(tiersId) {
      if (!tiersId) return '';
      return this.bailleurList.find((bailleur) => {
        return bailleur.tiersId === tiersId;
      }).libelle;
    },
    getMontantByTiers(tiersId, key) {
      if (this.contrat.echeancier
        .filter((echeance) => { return echeance.tiersId === tiersId; }).length === 0) return 0;
      return this.contrat.echeancier
        .filter((echeance) => { return echeance.tiersId === tiersId; })
        .map((echeance) => {
          if (key === 'montantEcheancierPaye') {
            return echeance.aRapprocher
              ? echeance.montantEcheancierPaye : echeance.montantPaye;
          }
          return echeance[key];
        })
        .reduce((accumulator, currentValue) => { return accumulator + currentValue; });
    },
    getBailleur() {
      if (this.contrat.echeancier.length === 0) return [];
      let bailleurList = this.contrat.intervenants.filter((int) => { return int.tiersId; })
        .map((intervenant) => {
          return { libelle: intervenant.tiers.nomCommercial, tiersId: intervenant.tiersId };
        });
      bailleurList = bailleurList.concat(this.contrat.echeancier
        .map((echeance) => {
          return { libelle: echeance.tiers.nomCommercial, tiersId: echeance.tiersId };
        }));
      const finalList = [];
      [...new Set(bailleurList.map((bailleur) => bailleur.tiersId))].forEach((tiersId) => {
        finalList.push({
          tiersId: tiersId,
          mustAppearInEcheanceList: true,
          libelle: bailleurList.find((bail) => { return bail.tiersId === tiersId; }).libelle,
        });
      });
      return finalList.sort((a, b) => {
        return a.libelle.localeCompare(b.libelle);
      });
    },
    getTotalGeneral(key) {
      if (this.contrat.echeancier.length === 0) return 0;
      return this.contrat.echeancier
        .map((echeance) => {
          if (key === 'montantEcheancierPaye') {
            return echeance.aRapprocher
              ? echeance.montantEcheancierPaye : echeance.montantPaye;
          }
          return echeance[key];
        })
        .reduce((accumulator, currentValue) => { return accumulator + currentValue; });
    },
    getLignesWithTiersId(tiersId, mustAppearInEcheanceList) {
      const ligne = this.contrat.echeancier.filter((ligne) => {
        return (ligne.tiersId === tiersId && mustAppearInEcheanceList
          && (!this.masquerEcheancePaye
            || (this.masquerEcheancePaye
              && (ligne.montantHt !== ligne.montantPaye || ligne.montantHt === 0))));
      });
      sortEcheance(ligne, this.sort);
      return ligne;
    },
    actionSecondary(ligne) {
      const actions = [];
      if (this.isClearedWithoutBill(ligne)) {
        actions.push({
          label: this.$t('detailContrat.echeancier.tabEcheance.actions.reactiver'),
          action: () => { this.reactiverEcheanceSoldee(ligne); },
        });
      }
      return actions;
    },
    actionSecondaryPay(ligne) {
      const actions = [];
      if (this.canCancelBill(ligne)) {
        actions.push({
          label: this.$t('detailContrat.echeancier.tabEcheance.actions.annulerCharge'),
          action: () => { this.popUpAnnulation = { show: true, target: ligne }; },
        });
      }

      if (this.canCancelPayment(ligne)) {
        actions.push({
          label: this.$t('detailContrat.echeancier.tabEcheance.actions.annulerPaiement'),
          action: () => { this.cancelPayment(ligne); },
        });
      }
      return actions;
    },
    payer(ligne) {
      if (!this.canPay(ligne)) return;
      if (ligne.problemeCoherenceEcheancierFacturation) {
        messageErreur(this.$i18n, this.$i18n.t('ajoutEditContrat.echeancier.tabEcheance.message.erreurCoherenceEcheancierFacturation'));
        return;
      }
      this.lineSelected = ligne;
      this.displayPopupPayer = true;
    },
    async closeAndSearch() {
      this.displayPopupPayer = false;
      this.displayPopupAnnulationPaiement = false;
      this.popUpAnnulation.show = false;
      await this.loadEcheancier();
    },
    async loadEcheancier() {
      const echeancier = this.avecHisto
        && this.contrat.allParentsIds !== null
        && this.contrat.allParentsIds.length > 0
        ? (await getEcheancierContrats(this.contrat.allParentsIds)).data.result
        : (await getEcheancierContrat(this.$route.params.id)).data.result;
      echeancier.forEach((echeance) => {
        echeance.debutPeriode = moment(echeance.debutPeriode).toDate();
        echeance.finPeriode = moment(echeance.finPeriode).toDate();
        echeance.dateEcheance = moment(echeance.dateEcheance).toDate();
        echeance.selected = false;
      });
      this.contrat.echeancier = echeancier;
    },
    canPay(ligne) {
      return !this.isPaid(ligne) && !ligne.aRapprocher
        && this.contrat.etat !== contratConf.CONTRAT_ETAT_BROUILLON
        && !this.isClearedWithoutBill(ligne);
    },
    isPaid(ligne) {
      return Math.abs(ligne.montantPaye) >= Math.abs(ligne.montantHt)
        && Math.abs(ligne.montantHt) > 0;
    },
    async annulerCharge(ligne, checkbox) {
      const idCommande = ligne.devisCommandeId;
      if (ligne.problemeCoherenceEcheancierFacturation) {
        messageErreur(this.$i18n, this.$i18n.t('ajoutEditContrat.echeancier.tabEcheance.message.erreurCoherenceEcheancierFacturation'));
        return;
      }
      const loadingComponent = this.$buefy.loading.open();
      try {
        await suppressionCharge(idCommande, checkbox);
        messageSucces(this.$i18n.t('ajoutEditContrat.echeancier.tabEcheance.message.successAnnulerCharge'));
        loadingComponent.close();
        await this.closeAndSearch();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    cancelPayment(ligne) {
      if (ligne.problemeCoherenceEcheancierFacturation) {
        messageErreur(this.$i18n, this.$i18n.t('ajoutEditContrat.echeancier.tabEcheance.message.erreurCoherenceEcheancierFacturation'));
        return;
      }
      this.lineSelected = ligne;
      this.displayPopupAnnulationPaiement = true;
    },
    canCancelBill(echeance) {
      return ((echeance.etat === ECHEANCE_FACTURE
        || echeance.etat === ECHEANCE_FACTURE_PARTIELLEMENT) && echeance.montantPaye === 0
       && echeance.montantHt > 0 && echeance.aRapprocher === false)
       && !this.isClearedWithoutBill(echeance);
    },
    canCancelPayment(echeance) {
      return (echeance.etat === ECHEANCE_FACTURE
        || echeance.etat === ECHEANCE_FACTURE_PARTIELLEMENT)
        && echeance.montantPaye !== 0
        && echeance.montantHt > 0
        && !this.isClearedWithoutBill(echeance);
    },
    async handleAction(action) {
      const selectedEcheances = this.getAllEcheanceSelected();
      switch (action) {
        case ACTION_SOLDER_SANS_FACTURE:
          await this.actionSolderSansFacture(selectedEcheances);
          break;
        case ACTION_REACTIVER_ECHEANCE_SOLDEE:
          await this.actionReactiverEcheanceSoldee(selectedEcheances);
          break;
        case ACTION_GENERATION_FACTURE:
          this.popUpPrevention.champsVide = [];
          this.popUpPrevention.messagesChampsVide = [];
          this.popUpPrevention.messagesPopup = [];
          this.popUpPrevention.isErrorPopup = false;
          this.popUpGeneration = true;
          break;
        default:
          break;
      }
    },
    getAllEcheanceSelected() {
      return this.contrat.echeancier.filter((echeance) => {
        return echeance.selected !== undefined && echeance.selected === true;
      });
    },
    selectAll() {
      const select = !this.allEcheanceSelected;
      this.contrat.echeancier.forEach((el) => {
        if (el.selected !== undefined) {
          el.selected = select;
        }
      });
    },
    async solderSansFacture(ligne) {
      await this.actionSolderSansFacture([ligne]);
    },
    async reactiverEcheanceSoldee(ligne) {
      await this.actionReactiverEcheanceSoldee([ligne]);
    },
    async generationFacture() {
      const echeances = this.getAllEcheanceSelected();
      const loadingComponent = this.$buefy.loading.open();
      try {
        const facture = (
          await factureGenerationFromEcheances(echeances.map(e => e.devisCommandeId))
        ).data.result;
        this.popUpGeneration = false;
        this.$router.push({ name: 'm.baux.facture_achat-edition', params: { id: facture.id, aRapprocher: true } });
      } catch (e) {
        if (e.response && e.response.data.error) {
          validationEcheance(e.response, this.popUpPrevention.messagesPopup);
          this.popUpPrevention.isErrorPopup = true;
          return;
        }
        messageErreur(this.$i18n);
      } finally {
        loadingComponent.close();
      }
    },
    async actionSolderSansFacture(echeances) {
      this.champsVide = [];
      this.messagesChampsVide = [];
      this.messages = [];
      this.error = false;
      echeances.forEach(ech => {
        if (ech.aRapprocher) {
          this.messages.push({
            message: 'detailContrat.echeancier.actionErrors.noARapprocher',
            parametres: {
              bailleur: this.getLibelleTier(ech.tiersId),
              dateEch: formatDate(ech.dateEcheance),
            },
          });
        }
        if (ech.etat === ECHEANCE_FACTURE || ech.etat === ECHEANCE_FACTURE_PARTIELLEMENT) {
          this.messages.push({
            message: 'detailContrat.echeancier.actionErrors.badStateFacture',
            parametres: {
              bailleur: this.getLibelleTier(ech.tiersId),
              dateEch: formatDate(ech.dateEcheance),
            },
          });
        }
        if (ech.etat === ECHEANCE_BROUILLON) {
          this.messages.push({
            message: 'detailContrat.echeancier.actionErrors.badStateBrouillon',
            parametres: {
              bailleur: this.getLibelleTier(ech.tiersId),
              dateEch: formatDate(ech.dateEcheance),
            },
          });
        }
        if (ech.etat === ECHEANCE_PAYEE) {
          this.messages.push({
            message: 'detailContrat.echeancier.actionErrors.badStatePayee',
            parametres: {
              bailleur: this.getLibelleTier(ech.tiersId),
              dateEch: formatDate(ech.dateEcheance),
            },
          });
        }
      });
      this.error = this.messages.length > 0;
      if (this.error) return;

      const loadingComponent = this.$buefy.loading.open();
      try {
        const ids = [];
        echeances.forEach(ech => {
          ids.push(ech.devisCommandeId);
        });
        await solderSansFacture(ids);
        await this.loadEcheancier();
        loadingComponent.close();
      } catch (e) {
        if (e.response && e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide);
          validationEcheance(e.response, this.messages);
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async actionReactiverEcheanceSoldee(echeances) {
      this.champsVide = [];
      this.messagesChampsVide = [];
      this.messages = [];
      this.error = false;
      echeances.forEach(ech => {
        if (ech.aRapprocher) {
          this.messages.push({
            message: 'detailContrat.echeancier.actionErrors.noARapprocher',
            parametres: {
              bailleur: this.getLibelleTier(ech.tiersId),
              dateEch: formatDate(ech.dateEcheance),
            },
          });
        }
        if (!this.isClearedWithoutBill(ech)) {
          this.messages.push({
            message: 'detailContrat.echeancier.actionErrors.notClearedWithoutBill',
            parametres: {
              bailleur: this.getLibelleTier(ech.tiersId),
              dateEch: formatDate(ech.dateEcheance),
            },
          });
        }
        if (ech.etat === ECHEANCE_BROUILLON) {
          this.messages.push({
            message: 'detailContrat.echeancier.actionErrors.badStateBrouillon',
            parametres: {
              bailleur: this.getLibelleTier(ech.tiersId),
              dateEch: formatDate(ech.dateEcheance),
            },
          });
        }
        if (ech.etat === ECHEANCE_PAYEE) {
          this.messages.push({
            message: 'detailContrat.echeancier.actionErrors.badStatePayee',
            parametres: {
              bailleur: this.getLibelleTier(ech.tiersId),
              dateEch: formatDate(ech.dateEcheance),
            },
          });
        }
      });
      this.error = this.messages.length > 0;
      if (this.error) return;

      const loadingComponent = this.$buefy.loading.open();
      try {
        const ids = [];
        echeances.forEach(ech => {
          ids.push(ech.devisCommandeId);
        });
        await reactiverSuiteSoldeSansFacture(ids);
        await this.loadEcheancier();
        loadingComponent.close();
      } catch (e) {
        if (e.response && e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide);
          validationEcheance(e.response, this.messages);
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    isClearedWithoutBill(echeance) {
      return (echeance.etat === ECHEANCE_FACTURE
        || echeance.etat === ECHEANCE_FACTURE_PARTIELLEMENT)
        && !(echeance.factures && echeance.factures.length > 0);
    },
    colFacturee(echeance) {
      if (this.isClearedWithoutBill(echeance)) {
        return this.$i18n.t('detailContrat.echeancier.soldeSansFacture');
      }
      return formatDevise(echeance.montantAppele);
    },
    colPayee(echeance) {
      if (this.isClearedWithoutBill(echeance)) {
        return '';
      }
      return formatDevise(echeance.montantPaye);
    },
    getTermePaiement(infosTerme) {
      const termePaiement = contratConf.LISTE_TERME_PAIEMENT.find((terme) => {
        return terme.code === infosTerme;
      });
      return termePaiement ? termePaiement.libelle : '';
    },
    showIndexationEcheancier(ligne) {
      this.lineSelected = ligne;
      this.popUpIndexationEch = true;
    },
    getMotifBlocageLibelle(motifBlocageId) {
      if (!motifBlocageId) return '';
      const motif = this.parametre(PARAMETRES_KEYS.motifBlocage)
        .find((m) => m.id === motifBlocageId);
      return motif?.libelle || '';
    },
    dropdownItems(ligne) {
      const actions = [];
      actions.push({
        action: () => this.setDetailProduit(ligne),
        libelle: this.modulePresseActive ? this.$t('ajoutEditContrat.echeancier.tabEcheance.produit')
          : this.$t('ajoutEditContrat.echeancier.tabEcheance.faceEcran'),
        id: 0,
      });
      if (ligne.referenceExterne && ligne.referenceExterne !== this.contrat.id) {
        actions.push(
          {
            action: () => { this.showbail(ligne); },
            libelle: this.$t('ajoutEditContrat.echeancier.tabEcheance.goToBail'),
            permissionAction: CONTRAT.lecture,
          },
        );
      }
      if (this.paramDemandeAvoirBailleurGirodMediasSpe) {
        actions.push(
          {
            action: () => { this.edition(ligne); },
            libelle: this.$t('ajoutEditContrat.echeancier.tabEcheance.demandeAvoirBailleur'),
          },
        );
      }
      return actions;
    },
    async edition(ligne) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await edition({
          ids: [ligne.devisCommandeId],
          extension: 'Docx',
          typeDonnee: TYPE_EDITION_DEMANDE_AVOIR_BAILLEUR,
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    getProduitLocationEtDiversLibelle(ligne) {
      return ligne.listeProduitsLocationEtDivers.length > 1
        ? this.$t('detailContrat.echeancier.tabEcheance.multiProduit')
        : (ligne.listeProduitsLocationEtDivers[0]?.libelle ?? '');
    },
    async showbail(ligne) {
      const routeData = await this.$router.resolve({
        name: 'c.baux.contrat',
        params: { id: ligne.referenceExterne },
      });
      window.open(routeData.href, '_blank');
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    paramDemandeAvoirBailleurGirodMediasSpe() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.demandeAvoirBailleurGirodMediasSpe.key);
    },
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    getListeEcheanceOutsideRange() {
      const messages = [];
      this.contrat.echeancier.forEach((echeance) => {
        if (echeance.referenceExterne === this.contrat.id.toString()
          && !this.isPaid(echeance)
          && (moment(echeance.dateEcheance).isBefore(moment(this.contrat.dateDebutEcheance))
          || moment(echeance.dateEcheance).isAfter(moment(this.contrat.dateFinEcheance)))) {
          messages.push({
            isLink: false,
            libelle: this.$t('ajoutEditContrat.echeancier.info.echeanceOutsidePeriode', {
              dateEcheance: formatDate(echeance.dateEcheance),
              tiers: echeance.tiers.nomCommercial,
              montantEcheance: echeance.montantHt,
              debutBail: formatDate(this.contrat.dateDebutEcheance),
              finBail: formatDate(this.contrat.dateFinEcheance),
            }),
          });
        }
      });
      return messages;
    },
    getListeMessageBlocage() {
      const messages = [];
      this.contrat.intervenants.filter(i => i.tiers.blocageReglement).forEach((i) => {
        const motifLibelle = this.getMotifBlocageLibelle(i.tiers.motifBlocageId);
        messages.push({
          isLink: false,
          libelle: this.$t('ajoutEditContrat.echeancier.info.bailleurBlocageReglement', {
            motif: motifLibelle || this.$t('ajoutEditContrat.echeancier.info.aucunMotifBlocage'),
            nom: i.tiers.nomCommercial,
          }),
        });
      });
      return messages;
    },
    hasMultipleBailleurInList() {
      return this.bailleurList.filter((bailleur) => {
        return bailleur.mustAppearInEcheanceList;
      }).length;
    },
    getHeightestDateFin() {
      if (this.contrat.echeancier.length === 0) return this.getDate(this.contrat.dateFinEcheance);
      let maxDateFin = this.contrat.echeancier[0].finPeriode;
      this.contrat.echeancier.forEach((echeance) => {
        if (moment(echeance.finPeriode) > moment(maxDateFin)) {
          maxDateFin = echeance.finPeriode;
        }
      });
      return this.getDate(maxDateFin);
    },
    getSmallestDateDebut() {
      if (this.contrat.echeancier.length === 0) return this.getDate(this.contrat.dateDebutEcheance);
      let minDateDebut = this.contrat.echeancier[0].debutPeriode;
      this.contrat.echeancier.forEach((echeance) => {
        if (moment(echeance.debutPeriode) < moment(minDateDebut)) {
          minDateDebut = echeance.debutPeriode;
        }
      });
      return this.getDate(minDateDebut);
    },
    iconSelectTotal() {
      if (this.allEcheanceSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    allEcheanceSelected() {
      return this.getAllEcheanceSelected().length === this.contrat.echeancier.length;
    },
    exportExcelQuery() {
      return {
        typeDonnee: EXPORT_EXCEL_TYPE_DONNEES_COMMANDE,
        typeExport: EXPORT_EXCEL_TYPE_EXPORT_ECHEANCIER,
        nomFichier: this.$i18n.t('detailContrat.echeancier.exportExcel.excelTitle'),
        parametresAdditionnels: {
          idContrat: this.contrat.id,
        },
      };
    },
    actions() {
      const actions = [
        {
          action: ACTION_SOLDER_SANS_FACTURE,
          translation: 'detailContrat.actions.solderSansFacture',
        },
        {
          action: ACTION_REACTIVER_ECHEANCE_SOLDEE,
          translation: 'detailContrat.actions.reactiverEcheanceSoldee',
        },
      ];

      if (this.contrat.etat === ENREGISTRE) {
        actions.push({
          action: ACTION_GENERATION_FACTURE,
          translation: 'detailContrat.actions.generationFacture',
        });
      }
      return actions;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.bailleurList = cloneDeep(this.getBailleur());
      if (this.contrat.echeancier.length > 0) this.afficherEcheancier = true;
      await this.loadParametres([PARAMETRES_KEYS.motifBlocage]);
      await this.loadParametresInterne(
        [PARAMETRES_INTERNE_KEYS.demandeAvoirBailleurGirodMediasSpe.key]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
